<script setup>
defineOptions({
  inheritAttrs: false
})
</script>

<template>
  <li role="presentation">
    <hr
      v-bind="$attrs"
      class="t-dropdown-divider"
      role="separator"
      aria-orientation="horizontal"
    />
  </li>
</template>

<style scoped lang="scss">
.t-dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid var(--p-gray-200);
}
</style>
